export enum MemberType {
  USER = "USER",
  LIBRARY = "LIBRARY",
}

export enum MemberStatus {
    ACTIVE = "ACTIVE",
    BLOCK = "BLOCK",
    DELETE = "DELETE"
}
